import { CheckedAddress } from '@sparkdotfi/common-universal'
import { Connector, useEnsAvatar, useEnsName } from 'wagmi'

import { TopbarWalletDropdownProps, WalletMode } from '../../components/topbar-wallet/TopbarWalletDropdown'
import { getWalletIcon } from './getWalletIcon'
import { useBlockExplorerAddressLink } from '@/domain/hooks/useBlockExplorerAddressLink'
import { EnsName } from '@/domain/types/EnsName'
import { WalletMode as ConnectedWalletMode } from '@/domain/wallet/useConnectedAddress'
import { assets } from '@/ui/assets'

interface UseConnectedWalletInfoParams {
  address: CheckedAddress | undefined
  connector: Connector | undefined
  isInSandbox: boolean
  onDisconnect: () => void
  onExitWatchWalletMode: () => void
  isMobileDisplay: boolean
  walletMode: ConnectedWalletMode
}

export function useConnectedWalletInfo({
  connector,
  address,
  isInSandbox,
  onDisconnect,
  onExitWatchWalletMode,
  isMobileDisplay,
  walletMode,
}: UseConnectedWalletInfoParams): TopbarWalletDropdownProps | undefined {
  const { data: ensName } = useEnsName({ address })
  const { data: ensAvatar } = useEnsAvatar({ name: ensName ?? undefined })
  const blockExplorerAddressLink = useBlockExplorerAddressLink({ address })

  if (!address) {
    return undefined
  }
  if (!connector && walletMode !== 'watch-wallet') {
    return undefined
  }

  const mode = getMode({ isInSandbox, walletMode })
  const avatar = ensAvatar ?? assets.walletIcons.default
  const walletIcon = getWalletIcon(connector)
  const handleDisconnect = walletMode === 'watch-wallet' ? onExitWatchWalletMode : onDisconnect

  return {
    dropdownTriggerInfo: {
      mode,
      avatar,
      address: CheckedAddress(address),
      ensName: ensName ? EnsName(ensName) : undefined,
    },
    dropdownContentInfo: {
      mode,
      walletIcon,
      address: CheckedAddress(address),
      onDisconnect: handleDisconnect,
      blockExplorerAddressLink,
    },
    isMobileDisplay,
  }
}

interface GetModeParams {
  isInSandbox: boolean
  walletMode: ConnectedWalletMode
}

function getMode({ isInSandbox, walletMode }: GetModeParams): WalletMode {
  if (isInSandbox) {
    return 'sandbox'
  }

  if (walletMode === 'watch-wallet') {
    return 'watch-wallet'
  }

  return 'connected'
}
